exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".messages-list{position:relative;height:calc(100% - 100px);overflow-y:scroll;padding:10px;padding-bottom:0}.messages-list>ul{margin-bottom:0;padding-left:0}.messages-list>ul li{list-style-type:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/styles/MessageList.scss
// module id = 355
// module chunks = 0